/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import Header from '../header/header';

const HEADER_HEIGHT = '90px';

export default function CatalogueLayout({ children }) {
  return (
    <React.Fragment>
      <Header className="sticky" />
      <main
        sx={{
          position: 'fixed',
          top: HEADER_HEIGHT,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          overflow: 'hidden',
        }}
      >
        {children}
      </main>
    </React.Fragment>
  );
}
